var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center","flex-direction":"column","align-items":"center"}},[_c('span',{staticStyle:{"font-size":"40px"}},[_vm._v("您访问的页面不存在哦")]),_c('img',{attrs:{"src":_vm.$store.state.backendHost + '/file/empty.png',"width":"300px","alt":"","ondragstart":"return false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }